export default "<app-modal-base-pagamento\n  (onSubmitEmitter)=\"onSubmit()\"\n  (onCancelEmitter)=\"onCancel()\"\n></app-modal-base-pagamento>\n";